/* BG COM : prix remisé de l'« Offre du mois », étiquette holographique (11/10/2026). Balisage et règles : snippets/bgcom-promo-price
   (même rendu en Liquid, source principale). Ici : garde-fou de date (page restée en cache après la fin de l'offre), surfaces peintes
   en JS (aperçu rapide, pack « Complétez »), changement de variante de la fiche. Chargé par layout/theme.liquid (defer) seulement
   pendant l'offre, pros compris (réglage bgcom.offre_pro). Pro chez qui la promo gagne : étiquette data-bgpp-pro (prix promo en
   centimes), retirée si l'appli Fly peint un prix pro plus bas ou égal (surcharge par référence, non lue en Liquid). */
(function () {
  'use strict';
  if (window.bgcomOffreHtml) return;
  var d = document, PRO = '.bgp-badge:not(.bgp-badge--sale)';
  /* remise par ligne tronquée au centime (comportement mesuré de Shopify sur cette boutique) ; demi supérieur : Math.round */
  function off(c, p) { return Math.floor(c * p / 100); }
  function fmt(c) {   /* format boutique, comme le filtre money : €1.234,50 */
    var n = Math.max(0, Math.round(+c || 0));
    return '€' + String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + ('0' + (n % 100)).slice(-2);
  }
  function today() {   /* AAAA-MM-JJ à Paris (fuseau de la boutique) */
    try {
      var o = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function (x) { o[x.type] = x.value; });
      return o.year + '-' + o.month + '-' + o.day;
    } catch (e) { return ''; }
  }
  function over(fin) { var t = fin && today(); return !!(t && t > fin); }
  function html(c, p, fin, mode, from, pro) {
    c = Math.round(+c) || 0; p = +p || 0; mode = mode || 'card';
    if (!c || p <= 0 || over(fin)) return '';
    var net = c - off(c, p), sr = '<span class="bgp-sr">';
    var h = '<span class="bgpp bgpp--' + mode + '" data-bgpp="' + p + '"' + (fin ? ' data-bgpp-fin="' + fin + '"' : '') + ' data-bgpp-mode="' + mode + '"' + (pro ? ' data-bgpp-pro="' + net + '"' : '') + '>' +
      '<span class="bgpp__row">' + sr + 'Prix remisé : </span><span class="bgpp__holo">' + (from ? '<small>dès</small>' : '') +
      '<b>' + fmt(net) + '</b><small>HT</small></span><s class="bgpp__was">' + sr + 'au lieu de </span>' + fmt(c) + (mode === 'pdp' ? ' HT' : '') + '</s></span>';
    if (mode !== 'sticky') h += '<span class="bgpp__ttc">' + fmt(Math.round(net * 1.2)) + ' TTC' + (mode === 'pdp' ? ' <s>' + sr + 'au lieu de </span>' + fmt(Math.round(c * 1.2)) + '</s>' : '') + '</span>';
    if (mode === 'card' || mode === 'tile') h += '<span class="bgpp__note">Offre du mois' + (fin ? ' · jusqu\'au ' + fin.slice(8, 10) + '/' + fin.slice(5, 7) : '') + '</span>';
    return h + '</span>';
  }
  /* l'étiquette visible d'un bloc (aucune si une pastille PRO y est, sauf étiquette d'un pro chez qui la promo gagne ; CSS identique) */
  function tag(el) {
    var e = el && el.querySelector('.bgpp:not([hidden])');
    return e && (e.hasAttribute('data-bgpp-pro') || !el.querySelector(PRO)) ? e : null;
  }
  /* prix réellement payé pour un bloc qui porte une étiquette (total du pack « Complétez », cartes Conditionnement de l'aperçu) */
  function net(el, c) { var e = tag(el); return e ? c - off(c, +e.getAttribute('data-bgpp') || 0) : c; }
  /* repeint l'étiquette d'un bloc pour un autre prix (variante choisie), même taux, même mode */
  function repaint(el, c) {
    var e = el && el.querySelector('.bgpp');
    if (!e) return;
    var h = html(c, e.getAttribute('data-bgpp'), e.getAttribute('data-bgpp-fin'), e.getAttribute('data-bgpp-mode'), false, e.hasAttribute('data-bgpp-pro'));
    if (!h) { e.hidden = true; return; }
    var t = d.createElement('span'); t.innerHTML = h;
    if (e.id) t.firstChild.id = e.id;
    e.parentNode.replaceChild(t.firstChild, e);
    best();
  }
  /* aperçu rapide (assets/bgcom-quick-view) : si la carte ouverte porte une étiquette, le prix de l'aperçu la suit */
  function qv(elPrice, card, v) {
    var e = tag(card);
    if (!elPrice || !e || !v) return;
    var h = html(v.price, e.getAttribute('data-bgpp'), e.getAttribute('data-bgpp-fin'), 'qv', false, e.hasAttribute('data-bgpp-pro'));
    if (h) elPrice.innerHTML = h;
  }
  /* garde-fou de date (page en cache ou restée ouverte après la fin) : tout ce qui porte data-bgpp-fin (étiquettes, prix barrés,
     mention du prix barré) se masque, sauf les montants remisés écrits en Liquid (cartes Conditionnement, accueil) qui reprennent
     leur contenu d'origine (data-bgpp-o, écrit par le thème) */
  function guard() {
    var t = today();
    if (t) [].forEach.call(d.querySelectorAll('[data-bgpp-fin]'), function (e) {
      if (t <= e.getAttribute('data-bgpp-fin')) return;
      if (e.hasAttribute('data-bgpp-o')) e.innerHTML = e.getAttribute('data-bgpp-o'); else e.hidden = true;
    });
  }
  /* changement de variante de la fiche : l'étiquette de la nouvelle variante vient du HTML que le thème vient de recevoir
     (rendu Liquid, une seule source de calcul) ; le « Produit actuel » du pack « Complétez » suit */
  function swap(fresh, id) {
    var live = d.getElementById(id), nu = fresh.getElementById(id);
    if (!live) return;
    if (nu) { live.parentNode.replaceChild(d.importNode(nu, true), live); best(); }
    else live.hidden = true;
  }
  /* pro : prix pro réellement peint par l'appli (data-bgcom-state « d<centimes> » du prix natif, snippets/samita-custom) ; s'il est
     plus bas ou égal au prix promo, l'étiquette s'efface et le prix pro revient (la meilleure remise s'applique au panier) */
  function best(root) {
    [].forEach.call((root || d).querySelectorAll('[data-bgcom-state^="d"]'), function (n) {
      var e = n.parentNode && n.parentNode.querySelector('.bgpp[data-bgpp-pro]:not([hidden])');
      if (e && parseInt(n.getAttribute('data-bgcom-state').slice(1), 10) <= +e.getAttribute('data-bgpp-pro')) e.hidden = true;
    });
  }
  function init() {
    guard();
    best();
    var q = 0;
    try { new MutationObserver(function () { if (!q) q = requestAnimationFrame(function () { q = 0; best(); }); }).observe(d.body, { subtree: true, attributes: true, attributeFilter: ['data-bgcom-state'] }); } catch (e) {}
    var ps = window.theme && window.theme.pubsub;
    if (!ps || typeof ps.subscribe !== 'function' || !ps.PUB_SUB_EVENTS || !ps.PUB_SUB_EVENTS.variantChange) return;
    ps.subscribe(ps.PUB_SUB_EVENTS.variantChange, function (ev) {
      try {
        var x = ev && ev.data;
        if (!x || !x.parsedHTML || !x.parsedHTML.getElementById) return;
        var k = '-' + x.sectionId + '-' + x.productId;
        swap(x.parsedHTML, 'BgppPdp' + k);
        swap(x.parsedHTML, 'BgppSticky' + k);
        var cur = x.variant && d.querySelector('[data-bgb-item][data-kind="current"]');
        if (cur) repaint(cur, x.variant.price);
      } catch (e) {}
    });
  }
  window.bgcomOffreHtml = html; window.bgcomOffreNet = net; window.bgcomOffreRepaint = repaint; window.bgcomOffreQv = qv;
  if (d.readyState === 'complete') init(); else d.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', function (e) { if (e.persisted) guard(); });
  d.addEventListener('visibilitychange', function () { if (!d.hidden) guard(); });
})();
